export default function TermsPage() {
  return (
    <div
      className="px-4 md:px-5"
      style={{
        direction: 'rtl',
        maxWidth: 900,
        margin: '0 auto',
        paddingTop: 40,
        paddingBottom: 40,
        fontFamily: 'sans-serif',
        lineHeight: 1.8,
        color: '#333',
      }}
    >
      <h1>תקנון ותנאי שימוש</h1>
      <p>
        <strong>עדכון אחרון: יולי 2026</strong>
      </p>

      <h2>1. כללי</h2>
      <p>
        אתר זה ושירותי הסליקה המוצעים בו מופעלים על ידי{' '}
        <strong>עמוטק – פתרונות דיגיטליים לעמותות בע&quot;מ</strong> (ח.פ.{' '}
        <strong>516866514</strong>), שכתובתה הרשומה{' '}
        <strong>עציון 27, פרדס חנה</strong>, טלפון{' '}
        <a href="tel:0538286227">053-828-6227</a> (להלן: &quot;<strong>החברה</strong>
        &quot; או &quot;<strong>עמוטק</strong>&quot;).
      </p>
      <p>
        השימוש באתר ו/או ביצוע תרומה / רכישה דרכו מהווים הסכמה מלאה לתנאי תקנון
        זה. אם אינך מסכים לתנאים — אנא הימנע מהשימוש באתר.
      </p>

      <h2>2. מהות העסקה</h2>
      <p>
        האתר מאפשר ביצוע תרומות ותשלומים לטובת עמותות וארגוני מגזר שלישי, באמצעות
        מערכת סליקה מאובטחת. עמוטק פועלת כסוחר הרשום מול חברות האשראי וכמפעילת
        הפלטפורמה הטכנולוגית עבור הארגון המוטב.
      </p>
      <p>
        סליקת כרטיסי האשראי מבוצעת באמצעות ספקי סליקה מורשים בלבד —{' '}
        <strong>Tranzila</strong> ו/או <strong>HyP (היפ)</strong> — בהתאם
        לדרישות תקן <strong>PCI-DSS</strong>. פרטי כרטיס האשראי אינם נשמרים
        בשרתי האתר.
      </p>

      <h2>3. מדיניות אספקת מוצר / שירות</h2>
      <ul>
        <li>
          <strong>אישור עסקה:</strong> אישור החיוב מתקבל מחברת הסליקה באופן
          מיידי בסיום התשלום ומוצג למשתמש במסך &quot;תודה&quot;.
        </li>
        <li>
          <strong>קבלה רשמית:</strong> קבלה רשמית (לרבות טופס 46 לתרומה לעמותה
          מוכרת לעניין סעיף 46 לפקודת מס הכנסה, כאשר רלוונטי) תישלח לכתובת
          הדואר האלקטרוני שמסר התורם <strong>תוך 3 ימי עסקים</strong> ממועד
          ביצוע העסקה.
        </li>
        <li>
          <strong>תרומה חודשית קבועה (הוראת קבע):</strong> חיוב חודשי מתבצע
          באותו יום בכל חודש, למשך מספר החודשים שבחר התורם. ניתן לבטל בכל עת
          לפי סעיף 4 להלן.
        </li>
        <li>
          אין באתר זה מכירה של מוצר פיזי הדורש משלוח.
        </li>
      </ul>

      <h2>4. מדיניות ביטול עסקה</h2>
      <p>
        ביטול עסקה ייעשה בהתאם להוראות <strong>חוק הגנת הצרכן, התשמ&quot;א-1981</strong>{' '}
        ולתקנות שהותקנו מכוחו (לרבות תקנות הגנת הצרכן (ביטול עסקה),
        התשע&quot;א-2010).
      </p>
      <ul>
        <li>
          ניתן לבטל עסקת תרומה חד-פעמית, וכן לבטל הוראת קבע לתרומה חודשית, בכל
          עת.
        </li>
        <li>
          בקשת ביטול תוגש בכתב לדוא&quot;ל{' '}
          <a href="mailto:support@amutech.co.il">support@amutech.co.il</a> או
          בטלפון <a href="tel:0538286227">053-828-6227</a>.
        </li>
        <li>
          הביטול ייכנס לתוקף בתוך 14 ימים ממועד קבלת ההודעה (או במועד המוקדם
          האפשרי מבחינה תפעולית מול חברת הסליקה).
        </li>
        <li>
          זיכוי כספי, ככל שיינתן, יבוצע לאותו כרטיס אשראי שבו בוצעה העסקה
          המקורית.
        </li>
      </ul>

      <h2>5. הגבלת גיל</h2>
      <p>
        ביצוע עסקת תרומה / תשלום באתר זה מותר רק לבני <strong>18 ומעלה</strong>{' '}
        בעלי כשרות משפטית להתחייב בעסקה. קטינים רשאים לבצע עסקה אך ורק באישור
        מפורש של הורה / אפוטרופוס.
      </p>

      <h2>6. מדיניות פרטיות והגנה על מידע</h2>
      <p>
        החברה פועלת בהתאם להוראות <strong>חוק הגנת הפרטיות, התשמ&quot;א-1981</strong>,
        לרבות <strong>תיקון מס&apos; 13</strong> לחוק (בתוקף מיום 14.8.2025),
        ולתקנות הגנת הפרטיות (אבטחת מידע), התשע&quot;ז-2017. לנושאי מידע עומדות
        זכויות עיון, תיקון, מחיקה והסרה מדיוור ישיר, כמפורט ב
        <a href="/privacy">מדיניות הפרטיות</a>.
      </p>
      <p>
        החברה מתחייבת <strong>שלא להעביר את פרטי הלקוח לצד שלישי</strong>,
        למעט:
      </p>
      <ul>
        <li>
          ספקי סליקת אשראי מורשים (Tranzila / HyP) — לצורך ביצוע העסקה בלבד.
        </li>
        <li>הארגון המוטב (העמותה לה מועברת התרומה) — לצורך הנפקת קבלה.</li>
        <li>רשויות אכיפה ובתי משפט — כאשר נדרש לכך על פי דין.</li>
      </ul>
      <p>
        פרטים מלאים מופיעים ב<a href="/privacy">מדיניות הפרטיות</a>, המהווה
        חלק בלתי נפרד מתקנון זה.
      </p>

      <h2>7. אבטחת מידע</h2>
      <p>
        האתר מאובטח באמצעות הצפנת <strong>TLS/SSL</strong>. סליקת כרטיסי אשראי
        מבוצעת בסביבה תואמת <strong>PCI-DSS Level 1</strong> אצל ספקי הסליקה.
        עמוטק אינה שומרת מספרי כרטיסי אשראי מלאים בשרתיה.
      </p>

      <h2>8. הגבלת אחריות</h2>
      <p>
        עמוטק עושה כל מאמץ להבטיח את זמינות ותקינות השירות, אך אינה אחראית
        להפסקות שירות הנובעות מגורמים שאינם בשליטתה (לרבות תקלות אצל ספקי הסליקה
        או ספקי תקשורת).
      </p>

      <h2>9. שינויים בתקנון</h2>
      <p>
        עמוטק רשאית לעדכן תקנון זה מעת לעת. הנוסח המעודכן יפורסם בעמוד זה ויחול
        על כל עסקה המתבצעת לאחר מועד העדכון.
      </p>

      <h2>10. דין וסמכות שיפוט</h2>
      <p>
        על תקנון זה יחולו דיני מדינת ישראל בלבד. סמכות השיפוט הבלעדית בכל סכסוך
        תהיה נתונה לבתי המשפט המוסמכים במחוז חיפה.
      </p>

      <h2>11. יצירת קשר</h2>
      <p>
        <strong>עמוטק – פתרונות דיגיטליים לעמותות בע&quot;מ</strong>
        <br />
        ח.פ. 516866514
        <br />
        עציון 27, פרדס חנה
        <br />
        טלפון: <a href="tel:0538286227">053-828-6227</a>
        <br />
        דוא&quot;ל: <a href="mailto:support@amutech.co.il">support@amutech.co.il</a>
      </p>
    </div>
  );
}
